(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 87794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(94336);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78182);
/* harmony import */ var _styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28564);
/* harmony import */ var _styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45992);








const ManagersSlider = ({ data  })=>{
    const settings = {
        dotsClass: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sliderDots),
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "managers-slidr",
        className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().regionaManagerSlider),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            ...settings,
            className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().slider),
            children: data.map((card)=>{
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sliderCardDiv),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().card),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Body */ .Z.Body, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().regiManagerImg),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        src: card?.imageUrl,
                                        layout: "responsive",
                                        height: 250,
                                        width: 250,
                                        className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().regiManagerImg),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Title */ .Z.Title, {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                    children: card?.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Title */ .Z.Title, {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().designation),
                                    children: card?.designation
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Subtitle */ .Z.Subtitle, {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().subtitle),
                                    children: card?.location
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Text */ .Z.Text, {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                                    children: card?.mobile
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Text */ .Z.Text, {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                                    children: card?.email
                                })
                            ]
                        })
                    })
                });
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ManagersSlider);


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 72767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Chevron = ({ width =13 , height =21 , color ="#0B0C2D"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 13 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.5 19L11.5 10.6667L1.5 1.5",
            stroke: color,
            "stroke-width": "3",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chevron);


/***/ }),

/***/ 68613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Mail = ({ width =14 , height =14 , color ="#9A9AB0"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.6677 2.74982L7.42255 6.09024C7.24456 6.1936 7.04239 6.24805 6.83655 6.24805C6.63071 6.24805 6.42854 6.1936 6.25054 6.09024L1.00012 2.74982M2.16688 1H11.501C12.1453 1 12.6677 1.52228 12.6677 2.16655V9.16585C12.6677 9.81012 12.1453 10.3324 11.501 10.3324H2.16688C1.5225 10.3324 1.00012 9.81012 1.00012 9.16585V2.16655C1.00012 1.52228 1.5225 1 2.16688 1Z",
            stroke: color,
            "stroke-width": "2",
            "stroke-linecap": "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Mail);


/***/ }),

/***/ 14523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// hooks/useIsMobile.ts

const useIsMobile = (breakpoint = 768)=>{
    const { 0: isMobile , 1: setIsMobile  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
        const handleChange = (e)=>{
            setIsMobile(e.matches);
        };
        // Set initial value
        setIsMobile(mediaQuery.matches);
        // Listen for changes
        mediaQuery.addEventListener("change", handleChange);
        return ()=>{
            mediaQuery.removeEventListener("change", handleChange);
        };
    }, [
        breakpoint
    ]);
    return isMobile;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 94336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Ratio.js
var Ratio = __webpack_require__(84883);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./styles/contcatus.module.scss
var contcatus_module = __webpack_require__(28564);
var contcatus_module_default = /*#__PURE__*/__webpack_require__.n(contcatus_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/ManagerCards.tsx
var ManagerCards = __webpack_require__(96138);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 7 modules
var react_select_esm = __webpack_require__(15707);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./components/LazyMedia/index.tsx
var LazyMedia = __webpack_require__(37462);
// EXTERNAL MODULE: ./components/ContactUs/OfficeAddress.module.scss
var OfficeAddress_module = __webpack_require__(51809);
var OfficeAddress_module_default = /*#__PURE__*/__webpack_require__.n(OfficeAddress_module);
// EXTERNAL MODULE: ./components/UI/Icons/Chevron.tsx
var Chevron = __webpack_require__(72767);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(14523);
;// CONCATENATED MODULE: ./components/UI/Icons/MapPin.tsx


const MapPin = ({ width =14 , height =14 , color ="#9A9AB0"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_15151_10)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.6658 5.83325C10.6657 4.86077 10.2799 3.92813 9.59253 3.24048C8.90497 2.55279 7.97203 2.16626 6.99976 2.16626C6.02758 2.16631 5.09547 2.55287 4.40796 3.24048C3.72042 3.92815 3.33377 4.86065 3.33374 5.83325C3.33374 6.95256 3.97351 8.21834 4.88062 9.4104C5.61394 10.3741 6.44359 11.184 6.99976 11.6877C7.55589 11.184 8.38552 10.3741 9.1189 9.4104C10.026 8.21834 10.6658 6.95256 10.6658 5.83325ZM7.74976 5.83325C7.7497 5.41882 7.41366 5.08325 6.99976 5.08325C6.58594 5.08335 6.24981 5.41888 6.24976 5.83325C6.24976 6.24768 6.58591 6.58315 6.99976 6.58325C7.41369 6.58325 7.74976 6.24774 7.74976 5.83325ZM9.74976 5.83325C9.74976 7.35194 8.51862 8.58325 6.99976 8.58325C5.48097 8.58315 4.24976 7.35188 4.24976 5.83325C4.24981 4.31467 5.48101 3.08335 6.99976 3.08325C8.51859 3.08325 9.7497 4.31461 9.74976 5.83325ZM12.6658 5.83325C12.6658 7.62678 11.6902 9.33416 10.7107 10.6213C9.70804 11.939 8.57129 12.9837 8.00366 13.4739L7.97827 13.4954L7.9519 13.5159C7.67756 13.7222 7.34305 13.8342 6.99976 13.8342C6.65658 13.8342 6.32285 13.7221 6.04858 13.5159L6.02124 13.4954L5.99585 13.4739C5.42822 12.9837 4.29147 11.939 3.28882 10.6213C2.30938 9.33418 1.33374 7.6267 1.33374 5.83325C1.33377 4.33048 1.93053 2.88917 2.99292 1.82642C4.05548 0.763651 5.49699 0.166309 6.99976 0.16626C8.50259 0.16626 9.94399 0.763607 11.0066 1.82642C12.0691 2.88918 12.6657 4.33039 12.6658 5.83325Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_15151_10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_MapPin = (MapPin);

;// CONCATENATED MODULE: ./components/UI/Icons/Phone.tsx


const Phone = ({ width =14 , height =14 , color ="#9A9AB0"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_15148_19168)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.00006 3.49978V7.00006L9.33358 8.16682M12.8339 7.00006C12.8339 10.222 10.222 12.8339 7.00006 12.8339C3.77814 12.8339 1.16626 10.222 1.16626 7.00006C1.16626 3.77814 3.77814 1.16626 7.00006 1.16626C10.222 1.16626 12.8339 3.77814 12.8339 7.00006Z",
                    stroke: color,
                    "stroke-width": "2",
                    "stroke-linecap": "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_15148_19168",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_Phone = (Phone);

// EXTERNAL MODULE: ./components/UI/Icons/Mail.tsx
var Mail = __webpack_require__(68613);
;// CONCATENATED MODULE: ./components/UI/Icons/Clock.tsx


const Clock = ({ width =14 , height =14 , color ="#9A9AB0"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_15148_19158)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8.45366 9.70078C8.32503 9.73291 8.1893 9.72027 8.06881 9.66494C6.44843 8.86968 5.13714 7.56003 4.33985 5.94064C4.2808 5.81952 4.2655 5.68169 4.29656 5.55057C4.32761 5.41944 4.4031 5.30311 4.51019 5.22133L4.78322 5.01657C4.92812 4.90789 5.04574 4.76696 5.12674 4.60495C5.20775 4.44294 5.24992 4.26429 5.24992 4.08316V2.33302C5.24992 2.02358 5.12699 1.72681 4.90818 1.508C4.68937 1.28919 4.3926 1.16626 4.08316 1.16626H2.33302C2.02358 1.16626 1.72681 1.28919 1.508 1.508C1.28919 1.72681 1.16626 2.02358 1.16626 2.33302C1.16626 5.11802 2.2726 7.78895 4.24188 9.75824C6.21117 11.7275 8.8821 12.8339 11.6671 12.8339C11.9765 12.8339 12.2733 12.7109 12.4921 12.4921C12.7109 12.2733 12.8339 11.9765 12.8339 11.6671V9.91696C12.8339 9.60752 12.7109 9.31075 12.4921 9.09194C12.2733 8.87313 11.9765 8.7502 11.6671 8.7502H9.91696C9.73583 8.7502 9.55718 8.79237 9.39517 8.87338C9.23316 8.95438 9.09223 9.072 8.98355 9.2169L8.77645 9.48818C8.69614 9.59367 8.58229 9.66865 8.45366 9.70078Z",
                    stroke: color,
                    "stroke-width": "2",
                    "stroke-linecap": "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_15148_19158",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_Clock = (Clock);

;// CONCATENATED MODULE: ./components/ContactUs/OfficeAddress.tsx












const OfficeAddress = ({ headOffice =constants/* HEAD_OFFICE */.zl , branchOffices =constants/* BRANCH_OFFICES */.UR  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(900);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (OfficeAddress_module_default())["address-section"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (OfficeAddress_module_default())["head-office"],
                children: [
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (OfficeAddress_module_default())["head-office-image"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: headOffice.image,
                                alt: headOffice.name,
                                layout: "fill",
                                objectFit: "cover"
                            }),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (OfficeAddress_module_default())["head-office-info"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OfficeAddress_module_default())["badge-container"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: headOffice.badge
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: (OfficeAddress_module_default())["head-office-name"],
                                        children: headOffice.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OfficeAddress_module_default())["head-field"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (OfficeAddress_module_default())["head-label"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_MapPin, {}),
                                            "Address"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (OfficeAddress_module_default())["head-value"],
                                        children: headOffice.address
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OfficeAddress_module_default())["head-field-row"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (OfficeAddress_module_default())["head-field"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (OfficeAddress_module_default())["head-label"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Phone, {}),
                                                    "Call"
                                                ]
                                            }),
                                            headOffice.callLines.map((line)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (OfficeAddress_module_default())["head-value"],
                                                    children: line
                                                }, line))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (OfficeAddress_module_default())["head-field"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (OfficeAddress_module_default())["head-label"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Mail/* default */.Z, {}),
                                                    "Email"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (OfficeAddress_module_default())["head-email-link"],
                                                children: headOffice.email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OfficeAddress_module_default())["head-field"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (OfficeAddress_module_default())["head-label"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Clock, {}),
                                            "Office Hours"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (OfficeAddress_module_default())["head-value"],
                                        children: headOffice.hours
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: headOffice.mapHref,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: (OfficeAddress_module_default())["map-button"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: (OfficeAddress_module_default())["show-on-gmap-btn"],
                                    children: [
                                        "Show on Google Maps ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                            width: 12,
                                            height: 12,
                                            color: "#ff7361"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (OfficeAddress_module_default())["head-office-image"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: headOffice.image,
                                alt: headOffice.name,
                                layout: "fill",
                                objectFit: "cover"
                            }),
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (OfficeAddress_module_default())["branch-offices-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (OfficeAddress_module_default())["section-title"],
                        children: "Student Counselling Offices"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OfficeAddress_module_default())["branch-grid"],
                        children: branchOffices.map((office)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OfficeAddress_module_default())["branch-card"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (OfficeAddress_module_default())["branch-map"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMedia/* default */.Z, {
                                            width: "100%",
                                            height: "190px",
                                            src: office?.mapImage
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (OfficeAddress_module_default())["branch-content"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: (OfficeAddress_module_default())["office-name"],
                                                children: office.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (OfficeAddress_module_default())["branch-field"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (OfficeAddress_module_default())["branch-field-label"],
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_MapPin, {}),
                                                            "Address"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (OfficeAddress_module_default())["branch-value"],
                                                        children: office.address
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (OfficeAddress_module_default())["branch-content-body"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (OfficeAddress_module_default())["branch-field-row"],
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (OfficeAddress_module_default())["branch-field"],
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: (OfficeAddress_module_default())["branch-field-label"],
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Phone, {}),
                                                                                    "Call"
                                                                                ]
                                                                            }),
                                                                            office.callLines.map((line)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (OfficeAddress_module_default())["branch-value"],
                                                                                    children: line
                                                                                }, line))
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (OfficeAddress_module_default())["branch-field"],
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: (OfficeAddress_module_default())["branch-field-label"],
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Mail/* default */.Z, {}),
                                                                                    "Email"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: (OfficeAddress_module_default())["branch-email-link"],
                                                                                children: office.email
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (OfficeAddress_module_default())["hours-container"],
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: (OfficeAddress_module_default())["branch-field-label"],
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Clock, {}),
                                                                            "Office hours"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: (OfficeAddress_module_default())["branch-value"],
                                                                        children: office.hours
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            href: office.mapHref,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            className: (OfficeAddress_module_default())["map-link"],
                                                            children: [
                                                                "Show on Google Maps",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                                                    width: 12,
                                                                    height: 12,
                                                                    color: "#ff7361"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, office.id))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ContactUs_OfficeAddress = (OfficeAddress);

;// CONCATENATED MODULE: ./components/ContactUsPage.tsx




















const Contactus = (props)=>{
    const router = (0,next_router.useRouter)();
    const videosSlidersettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
    };
    const { officeCountriesData , contactusData  } = props;
    const sortedOfficeCountriesData = sortBy_default()(officeCountriesData, "id");
    const { 0: selectedCountryId , 1: setSelectedCountryId  } = (0,react.useState)(sortedOfficeCountriesData[0].id);
    const { 0: filteredOfficeCountriesData , 1: setFilteredOfficeCountriesData  } = (0,react.useState)({});
    const { 0: kcOffices , 1: setKcOffices  } = (0,react.useState)([]);
    const { 0: kcOfficesFiltered , 1: setKcOfficesFiltered  } = (0,react.useState)([]);
    const { 0: kcOfficesCities , 1: setKcOfficesCities  } = (0,react.useState)([]);
    const { 0: selectedCity , 1: setSelectedCity  } = (0,react.useState)("");
    const { 0: officesLoader , 1: setOfficesLoader  } = (0,react.useState)(false);
    const scrollRef = (0,react.useRef)(null);
    const addressRef = (0,react.useRef)(null);
    const getOfficesData = (id, city, citiesCondition)=>{
        const searchCondition = city ? `&city_contains=${city}` : "";
        const officesUrl = `${"https://cms.studies-overseas.com"}/offices?office_country=${id}&_start=0&_sort=city:ASC${searchCondition}`;
        setOfficesLoader(true);
        (0,fetchUtil/* default */.Z)(officesUrl, "GET", {}, "", false).then((res)=>{
            if (res?.length > 0) {
                setKcOffices(res);
                setKcOfficesFiltered(res);
                const citiesList = res.map((officeData)=>{
                    return {
                        label: `${officeData.city}${officeData.area ? " " + officeData.area : ""}`,
                        value: `${officeData.city}${officeData.area ? " " + officeData.area : ""}`
                    };
                });
                citiesCondition && setKcOfficesCities(citiesList);
            } else {
                setKcOffices([]);
            }
        }).catch((err)=>{
            if (false) {}
        }).finally(()=>setOfficesLoader(false));
    };
    (0,react.useEffect)(()=>{
        getOfficesData(1, selectedCity, true);
    }, []);
    const officeCard = (office)=>{
        const { city , name , mobile , area  } = office;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
            id: "office-card",
            className: (contcatus_module_default()).contcatMainCard,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                    children: [
                        city,
                        " ",
                        area
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (contcatus_module_default()).contactCard,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: (contcatus_module_default()).icon,
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "226CF5",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M3.67857 17V17.75H5.17857V17H3.67857ZM12.8214 17V17.75H14.3214V17H12.8214ZM5.17857 17V14.7137H3.67857V17H5.17857ZM7.85714 12.0357H10.1429V10.5357H7.85714V12.0357ZM12.8214 14.7137V17H14.3214V14.7137H12.8214ZM10.1429 12.0357C11.6224 12.0357 12.8214 13.2345 12.8214 14.7137H14.3214C14.3214 12.4057 12.4504 10.5357 10.1429 10.5357V12.0357ZM5.17857 14.7137C5.17857 13.2345 6.37764 12.0357 7.85714 12.0357V10.5357C5.54955 10.5357 3.67857 12.4057 3.67857 14.7137H5.17857ZM9 3.67857C7.32342 3.67857 5.96429 5.03771 5.96429 6.71429H7.46429C7.46429 5.86613 8.15185 5.17857 9 5.17857V3.67857ZM12.0357 6.71429C12.0357 5.03771 10.6766 3.67857 9 3.67857V5.17857C9.84815 5.17857 10.5357 5.86613 10.5357 6.71429H12.0357ZM9 9.75C10.6766 9.75 12.0357 8.39086 12.0357 6.71429H10.5357C10.5357 7.56244 9.84815 8.25 9 8.25V9.75ZM9 8.25C8.15185 8.25 7.46429 7.56244 7.46429 6.71429H5.96429C5.96429 8.39086 7.32342 9.75 9 9.75V8.25ZM2.14286 1.75H15.8571V0.25H2.14286V1.75ZM16.25 2.14286V15.8571H17.75V2.14286H16.25ZM15.8571 16.25H2.14286V17.75H15.8571V16.25ZM1.75 15.8571V2.14286H0.25V15.8571H1.75ZM2.14286 16.25C1.92589 16.25 1.75 16.0741 1.75 15.8571H0.25C0.25 16.9025 1.09746 17.75 2.14286 17.75V16.25ZM16.25 15.8571C16.25 16.0741 16.0741 16.25 15.8571 16.25V17.75C16.9025 17.75 17.75 16.9025 17.75 15.8571H16.25ZM15.8571 1.75C16.0741 1.75 16.25 1.92589 16.25 2.14286H17.75C17.75 1.09746 16.9025 0.25 15.8571 0.25V1.75ZM2.14286 0.25C1.09746 0.25 0.25 1.09746 0.25 2.14286H1.75C1.75 1.92589 1.92589 1.75 2.14286 1.75V0.25Z",
                                    fill: "#226CF5"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: name
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (contcatus_module_default()).contactCard,
                    style: {
                        marginBottom: "0px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: (contcatus_module_default()).icon,
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M5.82197 1H3.28571C2.02335 1 1 2.02335 1 3.28571V5.57143C1 11.8833 6.11675 17 12.4286 17H14.7143C15.9767 17 17 15.9767 17 14.7143V13.1349C17 12.702 16.7554 12.3063 16.3682 12.1127L13.6072 10.7322C12.9851 10.4211 12.2318 10.7332 12.0119 11.393L11.6716 12.4139C11.4511 13.0752 10.7728 13.4688 10.0892 13.3321C7.35347 12.785 5.21502 10.6465 4.66787 7.91076C4.53116 7.22723 4.92483 6.54887 5.58612 6.32843L6.85313 5.9061C7.41967 5.71725 7.7453 5.12406 7.60046 4.54471L6.9307 1.86567C6.80351 1.35691 6.34639 1 5.82197 1Z",
                                    stroke: "#226CF5",
                                    strokeWidth: "1.5"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: mobile
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (contcatus_module_default()).arrowClass,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        height: 40,
                        width: 40,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M640 768c-12.8 0-21.333333-4.266667-29.866667-12.8-17.066667-17.066667-17.066667-42.666667 0-59.733333l213.333333-213.333333c17.066667-17.066667 42.666667-17.066667 59.733333 0s17.066667 42.666667 0 59.733333l-213.333333 213.333333C661.333333 763.733333 652.8 768 640 768z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M853.333333 554.666667c-12.8 0-21.333333-4.266667-29.866667-12.8l-213.333333-213.333333c-17.066667-17.066667-17.066667-42.666667 0-59.733333s42.666667-17.066667 59.733333 0l213.333333 213.333333c17.066667 17.066667 17.066667 42.666667 0 59.733333C874.666667 550.4 866.133333 554.666667 853.333333 554.666667z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M853.333333 554.666667 170.666667 554.666667c-25.6 0-42.666667-17.066667-42.666667-42.666667s17.066667-42.666667 42.666667-42.666667l682.666667 0c25.6 0 42.666667 17.066667 42.666667 42.666667S878.933333 554.666667 853.333333 554.666667z"
                            })
                        ]
                    })
                })
            ]
        });
    };
    const getCountryName = ()=>sortedOfficeCountriesData.length > 0 && sortedOfficeCountriesData.filter((country)=>country.id === selectedCountryId)[0].countryName;
    (0,react.useEffect)(()=>{
        if (selectedCity) {
            const filteredOffices = kcOffices?.length > 0 && kcOffices.filter((office)=>office.city === selectedCity || office.city + " " + office.area === selectedCity);
            setKcOfficesFiltered(filteredOffices);
        } else setKcOfficesFiltered(kcOffices);
    }, [
        selectedCity
    ]);
    (0,react.useEffect)(()=>{
        setFilteredOfficeCountriesData(sortedOfficeCountriesData.filter((country)=>country.id === selectedCountryId)[0]);
    }, [
        selectedCountryId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                as: "image",
                href: "/images/contcatus/contcat-us-start-img.svg",
                fetchPriority: "high"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "contcatus-section",
                className: (contcatus_module_default()).contcatus_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (contcatus_module_default()).breadcrum,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                lg: 8,
                                md: 8,
                                xs: 12,
                                className: (contcatus_module_default()).centered,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                href: "/",
                                                style: {
                                                    opacity: 0.5
                                                },
                                                children: "Home"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                href: "",
                                                children: " Contact Us "
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (contcatus_module_default()).heading,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                children: contactusData?.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: contactusData?.subTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (contcatus_module_default()).buttongp,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: `${(contcatus_module_default()).enquirebtn} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(contactusData?.meta?.jotforms[0]?.jotformid)}`,
                                                        onClick: ()=>{
                                                            !contactusData?.meta?.jotforms[0]?.jotformId && router.push(contactusData?.externalLink);
                                                        },
                                                        children: contactusData?.bannerBtn?.label || "Enquire Now"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (contcatus_module_default()).kcbtn,
                                                        onClick: ()=>addressRef?.current?.scrollIntoView(),
                                                        children: "KC Overseas Head Office"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "our-offices",
                className: (contcatus_module_default()).our_offices,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            lg: 8,
                            className: (contcatus_module_default()).centered,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (contcatus_module_default()).offices,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xl: 12,
                                            md: 12,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "Our Offices"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (contcatus_module_default()).country_offices,
                                    ref: scrollRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: sortedOfficeCountriesData?.length > 0 && sortedOfficeCountriesData.map((office)=>{
                                            const { countryName , flag: { url , alternativeText , formats  } , id ,  } = office;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                md: 4,
                                                lg: 4,
                                                xs: 6,
                                                sm: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: `${(contcatus_module_default()).country_flags} ${selectedCountryId === id ? (contcatus_module_default()).activeCountry : ""}`,
                                                    onClick: ()=>{
                                                        setSelectedCity("");
                                                        setKcOffices([]);
                                                        setKcOfficesFiltered([]);
                                                        setSelectedCountryId(id);
                                                        getOfficesData(id, "", true);
                                                        scrollRef?.current?.scrollIntoView({
                                                            block: "start"
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (contcatus_module_default()).flagImgContent,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: `${url}`,
                                                                alt: `${alternativeText}`,
                                                                width: 45,
                                                                height: 25
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: countryName
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, id);
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            kcOfficesFiltered?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "all-offices",
                className: (contcatus_module_default()).all_offices,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 9,
                                    md: 8,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: filteredOfficeCountriesData?.sectionTitle ?? "Offices in " + getCountryName()
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 3,
                                    md: 4,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                                        options: kcOfficesCities,
                                        placeholder: "Select Office",
                                        className: (contcatus_module_default()).selectClass,
                                        classNamePrefix: "mySelect",
                                        isClearable: true,
                                        value: selectedCity ? {
                                            label: selectedCity,
                                            value: selectedCity
                                        } : "",
                                        onChange: (selected)=>setSelectedCity(selected?.value || ""),
                                        theme: (theme)=>({
                                                ...theme,
                                                borderRadius: 5
                                            })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                id: "officesContain",
                                className: (contcatus_module_default()).officesContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: officesLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "Loading..."
                                        }) : kcOfficesFiltered?.length > 0 && kcOfficesFiltered.map((office)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 4,
                                                md: 6,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: `/contact-us/${office?.slug || ""}`,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                                            className: (contcatus_module_default()).card,
                                                            children: officeCard(office)
                                                        })
                                                    })
                                                })
                                            }, office.id);
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            filteredOfficeCountriesData?.regionalManagers && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "reg-manag",
                className: (contcatus_module_default()).regionalManagers,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: filteredOfficeCountriesData.regionalManagers.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            id: "regional-managers",
                            children: filteredOfficeCountriesData.regionalManagers.managerCard?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagerCards/* default */.Z, {
                                data: filteredOfficeCountriesData.regionalManagers.managerCard
                            })
                        })
                    ]
                })
            }),
            filteredOfficeCountriesData?.countrySalesManagers && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (contcatus_module_default()).regionalSalesManagers,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: filteredOfficeCountriesData.countrySalesManagers.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: filteredOfficeCountriesData.countrySalesManagers.managerCard?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagerCards/* default */.Z, {
                                data: filteredOfficeCountriesData.countrySalesManagers.managerCard
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "regional-manvedio",
                className: (contcatus_module_default()).regionalManVedio,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: contactusData?.rmVideoTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            ...videosSlidersettings,
                            children: contactusData.rmVideos.length > 0 && contactusData.rmVideos.map((video)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (contcatus_module_default()).mangerVideo,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratio/* default */.Z, {
                                                aspectRatio: "16x9",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMedia/* default */.Z, {
                                                    type: "image/svg+xml",
                                                    src: video.imageUrl,
                                                    tag: "embed"
                                                })
                                            })
                                        })
                                    })
                                });
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "office-address",
                className: (contcatus_module_default()).officeAddress,
                ref: addressRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUs_OfficeAddress, {})
            })
        ]
    });
};
/* harmony default export */ var ContactUsPage = (Contactus);

// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
;// CONCATENATED MODULE: ./pages/contact-us.tsx




const ContactUs = (props)=>{
    const { meta  } = props.contactusData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#226CF5");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsPage, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var contact_us = (ContactUs);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 51809:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"OfficeAddress_hide-scrollbar__yjZq3","address-section":"OfficeAddress_address-section__DeGFE","head-office":"OfficeAddress_head-office__xuS16","head-office-info":"OfficeAddress_head-office-info__w0wDW","head-office-image":"OfficeAddress_head-office-image__ku404","badge-container":"OfficeAddress_badge-container__FxIRI","head-office-name":"OfficeAddress_head-office-name__MmyIB","office-name":"OfficeAddress_office-name___teMj","head-field":"OfficeAddress_head-field__q_QXe","map-button":"OfficeAddress_map-button__N1lor","show-on-gmap-btn":"OfficeAddress_show-on-gmap-btn__t_A9n","head-field-row":"OfficeAddress_head-field-row__p3jEr","hours-container":"OfficeAddress_hours-container__MeMdI","head-label":"OfficeAddress_head-label__8nCge","head-value":"OfficeAddress_head-value__V3i_f","head-email-link":"OfficeAddress_head-email-link__V_Hxy","branch-offices-container":"OfficeAddress_branch-offices-container__B59U4","section-title":"OfficeAddress_section-title__SP_qe","branch-grid":"OfficeAddress_branch-grid__HpG9F","branch-card":"OfficeAddress_branch-card__hN3Xb","branch-map":"OfficeAddress_branch-map__IEI3m","branch-content":"OfficeAddress_branch-content__vOR4d","branch-content-body":"OfficeAddress_branch-content-body__NUDxl","branch-field":"OfficeAddress_branch-field__CK4gY","branch-field-row":"OfficeAddress_branch-field-row__vQq_w","branch-field-label":"OfficeAddress_branch-field-label__Ll_wK","branch-value":"OfficeAddress_branch-value__pVMkn","branch-email-link":"OfficeAddress_branch-email-link__MBRbz","branch-label":"OfficeAddress_branch-label__knYXO","divider":"OfficeAddress_divider__Ka3t9","map-link":"OfficeAddress_map-link__kO2mY"};

/***/ }),

/***/ 28564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contcatus_section":"contcatus_contcatus_section__KPipa","breadcrum":"contcatus_breadcrum__iZBVT","active":"contcatus_active__Dbjmi","enquirebtn":"contcatus_enquirebtn__2flvt","heading":"contcatus_heading__XBO8r","buttongp":"contcatus_buttongp__k6jZa","kcbtn":"contcatus_kcbtn__Shytg","centered":"contcatus_centered__nFqbD","our_offices":"contcatus_our_offices__m6543","offices":"contcatus_offices__JD9Dq","inputBox":"contcatus_inputBox__JGUIu","inputBtn":"contcatus_inputBtn__ZhubC","activeCountry":"contcatus_activeCountry__bY51u","country_flags":"contcatus_country_flags__obGUM","flagImgContent":"contcatus_flagImgContent__tFdRF","inputsearch":"contcatus_inputsearch__hRM00","all_offices":"contcatus_all_offices__BpLP1","viewMoreOffice":"contcatus_viewMoreOffice__xUR6_","card":"contcatus_card__YvE7h","contcatMainCard":"contcatus_contcatMainCard__0y9I5","contactCard":"contcatus_contactCard__EEQ82","icon":"contcatus_icon__nbjsA","arrowClass":"contcatus_arrowClass__btWWL","arrow":"contcatus_arrow__V_JKE","contactTabs":"contcatus_contactTabs__NJb9o","officesContainer":"contcatus_officesContainer__eaf3w","regionalManagers":"contcatus_regionalManagers__NPpJm","regionalSalesManagers":"contcatus_regionalSalesManagers__gicPI","card-title":"contcatus_card-title__hwfmv","regionaManagerSlider":"contcatus_regionaManagerSlider__cbeZl","salesManagerSlider":"contcatus_salesManagerSlider__ZAqJv","sliderCardDiv":"contcatus_sliderCardDiv__uHOTh","regiManagerImg":"contcatus_regiManagerImg__IlB9d","title":"contcatus_title__q4SKL","designation":"contcatus_designation__NBWFm","subtitle":"contcatus_subtitle__H35jp","text":"contcatus_text__toNdG","sliderDots":"contcatus_sliderDots__hUIsQ","regionalManVedio":"contcatus_regionalManVedio__7aY13","mangerVideo":"contcatus_mangerVideo__9v6ZR","officeAddress":"contcatus_officeAddress__oP9Tj","showMap":"contcatus_showMap__4H0EV","contactDetail":"contcatus_contactDetail__KwdFM","addDisplay":"contcatus_addDisplay__jNehd","content":"contcatus_content__ihu3P","para":"contcatus_para__RsU5c","addImg":"contcatus_addImg__u4ICx","map":"contcatus_map__CCyDg","viewMore":"contcatus_viewMore__egXfy","mobileAnchor":"contcatus_mobileAnchor__n2v3O","officeCountries":"contcatus_officeCountries__9zLZL"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,5707,9486,9774,2888,179], function() { return __webpack_exec__(87794); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);